__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "mfemaincontainer";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "2.13.0", () => (Promise.all([__webpack_require__.e(3313), __webpack_require__.e(9325)]).then(() => (() => (__webpack_require__(93313))))));
			register("axios", "1.20.0", () => (__webpack_require__.e(1623).then(() => (() => (__webpack_require__(11623))))));
			register("crypto-js", "4.2.0", () => (Promise.all([__webpack_require__.e(1396), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(21396))))));
			register("email-validator", "2.0.4", () => (__webpack_require__.e(8556).then(() => (() => (__webpack_require__(38556))))));
			register("i18next", "25.10.10", () => (__webpack_require__.e(2526).then(() => (() => (__webpack_require__(82526))))));
			register("react-click-away-listener", "2.4.2", () => (Promise.all([__webpack_require__.e(3641), __webpack_require__.e(6633)]).then(() => (() => (__webpack_require__(46633))))));
			register("react-dom", "19.3.0", () => (Promise.all([__webpack_require__.e(3641), __webpack_require__.e(961)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-i18next", "16.6.6", () => (Promise.all([__webpack_require__.e(5210), __webpack_require__.e(3641), __webpack_require__.e(5119)]).then(() => (() => (__webpack_require__(95210))))));
			register("react-router", "8.4.0", () => (Promise.all([__webpack_require__.e(8469), __webpack_require__.e(3641)]).then(() => (() => (__webpack_require__(48469))))));
			register("react", "19.3.0", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("redux-micro-frontend", "1.3.0", () => (Promise.all([__webpack_require__.e(3151), __webpack_require__.e(9325)]).then(() => (() => (__webpack_require__(53151))))));
			register("redux-persist", "6.0.0", () => (Promise.all([__webpack_require__.e(1385), __webpack_require__.e(9325)]).then(() => (() => (__webpack_require__(41385))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(1965).then(() => (() => (__webpack_require__(1965))))));
			register("scheduler", "0.28.0", () => (__webpack_require__.e(194).then(() => (() => (__webpack_require__(20194))))));
			initExternal(75007);
			initExternal(56689);
			initExternal(72391);
			initExternal(10337);
			initExternal(60521);
			initExternal(13513);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};